import { useContext } from "react";

import DashboardContext from "../../../Context";

import CreateCancel from "../../../components/forms/CreateCancel";
import Tabel from "../../../components/tabel/Tabel";
import FormWarranty from "./FormWarranty";
import { Col, Row } from "react-bootstrap";
import InputControlAsync from "../../../components/inputs/InputControlAsync";

const Warranty = () => {

    const { SohwaddFrom, handelFromTabel } = useContext(DashboardContext)

    const handelValue = (name, value) => {
        handelFromTabel({ workerId: value })
    }

    return (
        <>
            <CreateCancel />
            {
                SohwaddFrom ?
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '15px' }} >

                        <FormWarranty />
                    </div>
                    :
                    <><Row>
                        <Col>
                            <InputControlAsync url='/worker/search' label='انتخاب نیرو' name='customer' handelValue={handelValue} />
                        </Col>
                    </Row>
                        <Tabel />
                    </>
            }
        </>
    );
}

export default Warranty;
